/**
 * @author        jose.lucena@zumper.com (José Lucena)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   Fetch metro rent report thunk
 */

/* istanbul ignore file */
// ignore this file since it's tested with Cypress so it shouldn't punish overall coverage

import { is404Error } from '@zcode/error-filters'
import { BetaFeature, isBetaFeatureEnabled } from '@zcode/nr-utils'
import * as Api from '@zcode/nr/es/shared/api'
import { getRouteProps } from '@zcode/nr/es/shared/packages/history-middleware'
import invariant from 'tiny-invariant'
import { logger } from '../../../../logger'
import { selectCurrentSearchUrl } from '../../../currentSearch/selectors'
import type { Dispatch, GetState } from '../../../types'
import { receiveData } from '../../actions/metroRentReportModal'

export function loadMetroRentReport(url = '') {
  return async (dispatch: Dispatch, getState: GetState) => {
    try {
      const fallBackUrl = selectCurrentSearchUrl(getState())
      const loadedUrl = url || fallBackUrl
      invariant(loadedUrl)
      const { location } = dispatch(getRouteProps())

      const response = await Api.metroRentReport.get({
        url: loadedUrl,
        draft: isBetaFeatureEnabled(location, BetaFeature.DRAFT),
      })
      dispatch(receiveData(response))
    } catch (e) {
      if (!is404Error(e)) {
        logger.error(e)
      }
    }
  }
}
